var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import useRenderingPipeline from './hooks/useRenderingPipeline';
const OutputViewer = ({ sourcePlayback, backgroundConfig, segmentationConfig, postProcessingConfig, bodyPix, tflite, id, onCanvasRef, }) => {
    _react_refresh_temp_2();
    const { pipeline, canvasRef } = useRenderingPipeline(sourcePlayback, backgroundConfig, segmentationConfig, bodyPix, tflite);
    useEffect(() => {
        if (pipeline) {
            pipeline.updatePostProcessingConfig(postProcessingConfig);
        }
    }, [pipeline, postProcessingConfig]);
    useEffect(() => {
        const sendCanvasRef = () => {
            if (onCanvasRef && canvasRef) {
                onCanvasRef(canvasRef);
            }
        };
        const timeout = setTimeout(() => {
            sendCanvasRef();
        }, 500);
        return () => {
            clearTimeout(timeout);
        };
    }, [canvasRef]);
    return (_jsx("div", { className: "root preview-camera-webcam", children: _jsx("canvas", { ref: canvasRef, className: "render w-full my-5", width: sourcePlayback.width, height: sourcePlayback.height, id: id }, segmentationConfig.pipeline) }));
};
_react_refresh_temp_1 = OutputViewer;
$RefreshReg$(_react_refresh_temp_1, "OutputViewer");
_react_refresh_temp_2(OutputViewer, "Eb157vOLfx/ob+tSHD5CHt79OrM=", false, () => [useRenderingPipeline]);
export default OutputViewer;
